<template>
  <div id="email_campaign" class="flex flex-col proxima_nova text_color">
    <div v-if="loading" class="flex flex-col items-center justify-center gap-2 mt-20">
      <SkeletonLoader :page="loaderPages.TABLE" />
    </div>
    <div v-else>
      <CustomTabs v-model="activeKey" :tabs="tabs" />
      <SenderDetails v-if="activeKey === 0" />
      <SenderDomains v-if="activeKey === 1" />
    </div>
  </div>
</template>

<script setup>
import CustomTabs from "@/src/components/CustomTabs.vue";
import { onMounted, ref } from "vue";
import SenderDetails from "@/src/components/email_campaign_settigns/SenderDetails.vue";
import SenderDomains from "@/src/components/email_campaign_settigns/SenderDomains.vue";
import SuperCampaignsService from "@/src/api/SuperCampaignsService.js";
import { message } from "ant-design-vue";
import { loaderPages } from "@/src/constants/loaderConstants.js";
import SkeletonLoader from "@/src/components/SkeletonLoader.vue";

const tabs = [{ title: "Sender Details" }, { title: "Sender Domains" }];
const activeKey = ref(0);
const loading = ref(true);

onMounted(async () => {
  try {
    loading.value = true;
    const response = await SuperCampaignsService.fetchEmailDomains();
    if (response?.success) {
      console.log("Domains API response length:", response.domains.length);
      activeKey.value = response.domains.length === 0 ? 1 : 0;
    } else {
      activeKey.value = 1;
    }
  } catch (error) {
    message.error("An error occurred while fetching domains");
    console.error("Error while fetching sender domains: ", error);
    activeKey.value = 1;
  } finally {
    loading.value = false;
  }
});
</script>
